export interface UtmParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

const UTM_PARAMS_COOKIE_NAME = 'utm_params';
const UTM_PARAMS_COOKIE_MAX_AGE = 60 * 60 * 24; // 1 день в секундах

/**
 * Извлекает UTM параметры из URL
 */
export function extractUtmFromUrl(url?: string): UtmParams {
  const urlToParse =
    url || (typeof window !== 'undefined' ? window.location.href : '');
  if (!urlToParse) {
    return {};
  }

  const urlObj = new URL(urlToParse);
  const params: UtmParams = {};

  const utmKeys: (keyof UtmParams)[] = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];

  utmKeys.forEach((key) => {
    const value = urlObj.searchParams.get(key);
    if (value) {
      params[key] = value;
    }
  });

  return params;
}

/**
 * Проверяет, есть ли UTM параметры в объекте
 */
export function hasUtmParams(params: UtmParams): boolean {
  return Object.keys(params).length > 0;
}

/**
 * Формирует query string из UTM параметров
 */
export function buildUtmQueryString(params: UtmParams): string {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      searchParams.append(key, value);
    }
  });

  return searchParams.toString();
}

/**
 * Добавляет UTM параметры к URL
 */
export function addUtmToUrl(url: string, params: UtmParams): string {
  if (!hasUtmParams(params)) {
    return url;
  }

  try {
    const urlObj = new URL(url);
    const queryString = buildUtmQueryString(params);

    if (queryString) {
      // Добавляем UTM параметры к существующим query параметрам
      const existingParams = urlObj.searchParams.toString();
      const separator = existingParams ? '&' : '';
      urlObj.search = existingParams + separator + queryString;
    }

    return urlObj.toString();
  } catch {
    // Если URL некорректный, просто добавляем query string
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${buildUtmQueryString(params)}`;
  }
}

/**
 * Получает имя cookie для UTM параметров
 */
export function getUtmCookieName(): string {
  return UTM_PARAMS_COOKIE_NAME;
}

/**
 * Получает срок хранения cookie в секундах
 */
export function getUtmCookieMaxAge(): number {
  return UTM_PARAMS_COOKIE_MAX_AGE;
}
